import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ticketsFilter',
    pure: false
})
export class TicketFilter implements PipeTransform {
    transform(items: any[], filter: String, tecnico:String, provincia: String, soloEnGarantia: boolean): any {
        let ret = items;
        
        if(filter.length>0){
            filter = filter.toLocaleLowerCase();
            ret = ret.filter(item =>  item.tecnico_label.indexOf(filter) !== -1   );
        } 
        
        if(tecnico=='noasignado'){
           ret = ret.filter(item => !item.tecnico_asignado);
        }
        else{
            if(tecnico!='todos') ret = ret.filter(item => item.tecnico_asignado && item.tecnico_asignado._id == tecnico);
        }

        if(provincia!='todos') ret = ret.filter(item => item.zona.provincia == provincia);
        if(soloEnGarantia) ret = ret.filter(x => x.uso_garantia && x.uso_garantia == true);
        return ret;
    }
}